import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import Spinner from './components/ui/Spinner';

// Requires authenticated session
export function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-bg-primary"><Spinner size="lg" /></div>;
  return user ? <Outlet /> : <Navigate to="/" replace />;
}

// Redirects authenticated users away from auth pages
export function PublicOnlyRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen bg-bg-primary"><Spinner size="lg" /></div>;
  return user ? <Navigate to="/dashboard" replace /> : <Outlet />;
}
